import React from 'react';

function About() {
  return (
    <div className="container mx-auto p-8">
      <div className="bg-white rounded-lg mt-8 shadow-lg p-6 border border-gray-400">
        <h1 className="text-3xl font-bold  mb-6">About ATL Tech Events<sup>SM</sup></h1>
        
        <div className="space-y-4 text-left">
          <p>
            Welcome to the Beta version of ATL Tech Events. This is a work in progress and we are always looking for feedback.
          </p>
          <p>
            ATL Tech Events is your comprehensive resource for discovering and keeping track of 
            technology-related events in the greater Atlanta area. Our platform serves as a central hub 
            for the tech community, bringing together events from various organizations and groups.
          </p>

          <p>
            Our mission is to foster connection and growth within Atlanta's tech ecosystem by making 
            it easier for professionals, enthusiasts, and newcomers to find and participate in relevant 
            tech events.
          </p>

          <h2 className="text-2xl font-bold mt-6 mb-3">How it works</h2>
          <ul className="list-disc pl-6 space-y-2 text-left">
            <li>Any publicly available event we know about in the technology or technology-related space is added to the calendar. While our focus is in-person events, we may include some virtual events hosted by local organizations. Members-only events are generally not added, but exceptions are made when guests are permitted or the group sponsors the event listing.</li>
            <li>Private, invite-only commercial events are not added, but are can be added as a sponsored event for a small fee.</li>
            <li>We offer advertising and sponsorship opportunities to organizations that want to reach the tech community.</li>
            <li>To recommend an event or organization, correct any event information, learn about sponsoring or advertising, or add a private event, please contact us at <a target="_blank" rel="noopener noreferrer" className="text-blue-500" href="https://www.linkedin.com/company/atl-tech-events">ATL Tech Events on LinkedIn</a>.</li>
          </ul>

          <h2 className="text-2xl font-bold mt-6 mb-3">What about my city?</h2>
          <p>
            The platform is built to be easily customizable to other cities. If you are interested in leverging the platform for your city, please contact us at <a target="_blank" rel="noopener noreferrer" className="text-blue-500" href="https://www.linkedin.com/company/atl-tech-events">ATL Tech Events on LinkedIn</a>.
          </p>
          
          <h2 className="text-2xl font-bold mt-6 mb-3">Event Horizon Media<sup>SM</sup></h2>
          <p className="flex justify-center">
          <img src="event-horizon-media-logo.png" alt="Event Horizon Media Logo" className="w-1/2 rounded-full" />
          </p>
          <p>
            Event Horizon Media is a media and event platform service of Mirability, LLC, that produces the ATL Tech Events calendar and newsletter. Want to see the platform in your city? Let us know!
          </p>

        </div>
      </div>
    </div>
  );
}

export default About; 